module.exports = __webpack_public_path__ + "static/media/acura-bumper_selected.6f1cffdc.svg";